import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom/cjs/react-router-dom';

import {labels} from '../../../../util/utils';
import {projectStatusEnum} from '../../../../util/uiconstants';

import {getProjectToRollForward, setRollForwardMode} from '../../../../actions/Project/projectAction';
import {getAllAccessgroups} from '../../../../actions/AccessGroups/Accessgroupactions';

import selectAllClients from '../../../../reducers/Clients/selectors/selectAllClients';

import ProjectConfirmationModal from '../ProjectConfirmationModal';

const RollForwardModal = ({show, setShow, projectId, name, status}) => {
	const [isLoading, setIsLoading] = useState(false);

	const allProjects = useSelector(({allProjects}) => allProjects);
	const allClients = useSelector(selectAllClients);

	const dispatch = useDispatch();
	const history = useHistory();

	const onHide = () => setShow(false);

	const onConfirm = () => {
		if (status === projectStatusEnum.COMPLETED || status === projectStatusEnum.ACTIVE) {
			const projectClients = allProjects.find((p) => p.projectId === projectId).clients;
			const clientsToRollForward = projectClients.filter((c) =>
				allClients.find((ac) => ac.clientCode === c.clientCode)
			);
			setIsLoading(true);
			dispatch(getProjectToRollForward(projectId, clientsToRollForward)).then(() => {
				dispatch(getAllAccessgroups(projectId)).then(() => {
					dispatch(setRollForwardMode(true));
					history.push(`/projects/project`, null);
				});
			});
		}
	};

	const props = {
		show,
		onHide,
		onConfirm,
		isLoading,
		title: labels.rollForwardTitle,
		confirmLabel: labels.rollForward,
		instructional: labels.rollForwardInstructionalText,
		projectName: name || ''
	};

	return <ProjectConfirmationModal {...props} />;
};

RollForwardModal.propTypes = {};

RollForwardModal.defaultProps = {};

export default RollForwardModal;
